var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareReceipt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 2.22222V17.7778H2.22222V2.22222H17.7778ZM19 0H1C0.444445 0 0 0.444445 0 1V19C0 19.4444 0.444445 20 1 20H19C19.4444 20 20 19.4444 20 19V1C20 0.444445 19.4444 0 19 0ZM8.88889 4.44444H15.5556V6.66667H8.88889V4.44444ZM8.88889 8.88889H15.5556V11.1111H8.88889V8.88889ZM8.88889 13.3333H15.5556V15.5556H8.88889V13.3333ZM4.44444 4.44444H6.66667V6.66667H4.44444V4.44444ZM4.44444 8.88889H6.66667V11.1111H4.44444V8.88889ZM4.44444 13.3333H6.66667V15.5556H4.44444V13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareReceipt);
export default __webpack_public_path__ + "static/media/square-receipt.31d17800.svg";
export { ForwardRef as ReactComponent };